import { render, staticRenderFns } from "./TrackingRecommendation.vue?vue&type=template&id=57f81db6"
import script from "./TrackingRecommendation.vue?vue&type=script&lang=js"
export * from "./TrackingRecommendation.vue?vue&type=script&lang=js"
import style0 from "./TrackingRecommendation.vue?vue&type=style&index=0&id=57f81db6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports